import React, { useState, useEffect } from "react";
import { downloadProgress } from "../../utils/downloadProgressToast";
import "./DownloadProgressToast.css";

/**
 * Minimal & Professional Custom Download Progress Toast
 * Aligned with the exact white card, minimal dot, clean typography,
 * and bottom progress bar theme.
 */
export const DownloadProgressToast = () => {
  const [progressState, setProgressState] = useState(downloadProgress.getState());

  useEffect(() => {
    const unsubscribe = downloadProgress.subscribe((state) => {
      setProgressState(state);
    });
    return () => unsubscribe();
  }, []);

  if (!progressState.active) {
    return null;
  }

  const isComplete = progressState.isComplete || progressState.percent >= 100;

  const handleClose = () => {
    downloadProgress.close();
  };

  const displayTitle = isComplete
    ? (progressState.title.startsWith("Downloaded") || progressState.title.startsWith("Download complete")
        ? progressState.title
        : progressState.title.replace(/^Downloading\s+/i, "Downloaded "))
    : progressState.title;

  return (
    <div
      className={`custom-download-toast-card ${isComplete ? "state-complete" : "state-downloading"}`}
      role="status"
      aria-live="polite"
    >
      <button
        type="button"
        className="custom-download-toast-close"
        onClick={handleClose}
        aria-label="Close"
      >
        ×
      </button>

      <div className="custom-download-toast-body">
        <div className="custom-download-toast-title-row">
          <span className={`custom-download-toast-dot ${isComplete ? "dot-done" : "dot-active"}`} />
          <span className="custom-download-toast-title">{displayTitle}</span>
          <span className="custom-download-toast-percent">{progressState.percent}%</span>
        </div>

        {progressState.status && (
          <div className="custom-download-toast-message">
            {progressState.status}
          </div>
        )}
      </div>

      <div className="custom-download-toast-progress-track">
        <div
          className="custom-download-toast-progress-bar"
          style={{ width: `${progressState.percent}%` }}
        />
      </div>
    </div>
  );
};

export default DownloadProgressToast;
